import './App.scss';

// Libs
import { MemoryRouter, Switch, Route } from 'react-router-dom';

// Components
import HomeView from './views/home/home';
import GameView from './views/game/game';

function App() {
	return (
		<div className="App">
			<Switch>
				<Route render={props => {
									const gameView = window.location.href.includes('?game=');
									if(!gameView) {
										return <MemoryRouter>
												<HomeView closable={true}/>
											</MemoryRouter>
									} else {
										return <GameView {...props}/>;
							}
				}}>
				</Route>
			</Switch>
		</div>
	);
}

export default App;
